import {store} from "../store/store";
import {getAuthToken} from "./getAuthToken";
import {getRequest} from "./getRequest";
import {checkIsDemoAccount} from "./checkIsDemoAccount";

import {config} from "../config";

const isNativeApp = navigator.userAgent.indexOf("median") > -1 || window.median !== undefined;

export const validateToken = async () => {
  const token = await getAuthToken();

  let websiteURL = "";
  if (config.websiteId === 1) {
    websiteURL = "forthwithlife";
  } else if (config.websiteId === 2) {
    websiteURL = "sportsbloodtests";
  } else {
    websiteURL = "biomarkertracking";
  }

  return getRequest(`${import.meta.env.VITE_API_ROOT}/secure/validate`, token)
    .then(response => {
      if (response?.data?.status === 200) {
        localStorage.setItem("token", response.newToken);

        const isDemoAccount = checkIsDemoAccount(store.getState()?.user?.data?.ID);
        if (isDemoAccount) {
          document.cookie =
            "forthapptoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + websiteURL + ".co.uk";
        } else {
          document.cookie = "forthapptoken=" + response.newToken + "; domain=" + websiteURL + ".co.uk";
        }

        if (isNativeApp) {
          window.median?.storage?.app.set({
            key: "token",
            value: response.newToken,
          });
        }

        return true;
      }

      if (isNativeApp) {
        window.median?.storage?.app.set({
          key: "logoutReasonMedianToken",
          value: "token expired",
        });
      }

      return false;
    })
    .catch(e => {
      if (isNativeApp) {
        window.median?.storage?.app.set({
          key: "logoutReasonMedianToken",
          value: "token expired",
        });
      }
      return false;
    });
};
